export default class Validator {
    constructor() {
        this.key = '';
        this.value = '';
        this.errors = {};
        this.haveError = false;
    }

    setKey(key) {
        this.key = key;
        return this;
    }

    setValue(value) {
        this.value = value;
        return this;
    }

    required(msg = "هذا الحقل مطلوب") {
        if ( this.value == '' || this.value === null || this.value.length === 0) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true
        }
        return this;
    }

    max(maximam , msg) {
        if (this.value.length > maximam) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    len(lenght , msg) {
        if (this.value.length !== lenght) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    notMatch(MatchValue, msg) {
        if (this.value === MatchValue) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    confirm(MatchValue , msg) {
        if (this.value != MatchValue) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    is_arabic(msg) {
        let arabic = /[\u0600-\u06FF]/;
        if (!arabic.test(this.value)) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    is_valid_phone_number(msg = "اكتب رقم تيليفون صحيح رقم التلفون لازم يبدا بأي حاجه من دول 011/012/015/010 مينفعش يكوت في مسافات بين الارقام و مينفعش تكتب نفس الرقم ورا بعض اكتر من 4 مرات") {
        let valid = /^(011|012|010|015)(?!.*(\d)\2{4})\d{8}$/;
        if (!valid.test(this.value)) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    words_count(count ,msg) {
        if (this.value.split(' ').length < count) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    eng_number(msg) {
        let reg = /^\d+$/
        if (!reg.test(this.value)) {
            this.errors[this.key] = []
            this.errors[this.key].push(msg);
            this.haveError = true;
        }
        return this;
    }

    addError(msg) {
        this.errors[this.key] = []
        this.errors[this.key].push(msg);
        this.haveError = true
    }

    getErrors() {
        return this.errors;
    }

}